import { render } from "./MoveBoxOrGrid.vue?vue&type=template&id=57841bd7"
import script from "./MoveBoxOrGrid.vue?vue&type=script&lang=js"
export * from "./MoveBoxOrGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__